import type { RootState } from 'reducers/types';
import type { Dispatch } from 'redux';
import { heapAgent } from 'services/analytics/heapAgent/heapAgent';

type DispatchAction = Dispatch<{ type: string; payload?: unknown }>;

export const initializeHeapAgent =
  () => (_dispatch: DispatchAction, _getState: () => RootState) => {
    heapAgent.initialize();
  };
